import { render, staticRenderFns } from "./AccountTerminologyCreate.vue?vue&type=template&id=37142eeb"
import script from "./AccountTerminologyCreate.vue?vue&type=script&lang=js"
export * from "./AccountTerminologyCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports